/* global ajax_object */

/**
 * Case study archive — sector filter + AJAX "load more".
 */
const initCsArchive = (root) => {
  const grid = root.querySelector('[data-cs-grid]');
  const loadMore = root.querySelector('[data-cs-load-more]');
  const moreWrap = root.querySelector('.cs-archive__more');
  const tabs = Array.from(root.querySelectorAll('[data-cs-filter]'));

  if (!grid || typeof ajax_object === 'undefined') {
    return;
  }

  const exclude = root.dataset.exclude || '';
  const perPage = root.dataset.perPage || '9';
  let sector = 'all';
  let busy = false;

  const request = (paged) =>
    fetch(ajax_object.ajax_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams({
        action: 'case_study_posts',
        nonce: ajax_object.nonce,
        paged,
        sector,
        exclude,
        per_page: perPage,
      }),
    }).then((response) => response.json());

  const setLoadMore = (data) => {
    if (!loadMore || !moreWrap) {
      return;
    }

    loadMore.dataset.paged = String(data.paged);
    loadMore.dataset.max = String(data.max);
    moreWrap.hidden = data.paged >= data.max || data.max <= 1;
  };

  const filter = (next) => {
    if (busy || next === sector) {
      return;
    }

    busy = true;
    sector = next;

    tabs.forEach((tab) => {
      const active = tab.dataset.csFilter === sector;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    grid.classList.add('is-loading');

    request(1)
      .then((res) => {
        if (res && res.success) {
          grid.innerHTML = res.data.html;
          setLoadMore(res.data);
        }
      })
      .finally(() => {
        grid.classList.remove('is-loading');
        busy = false;
      });
  };

  const append = () => {
    if (busy || !loadMore) {
      return;
    }

    busy = true;
    const next = (parseInt(loadMore.dataset.paged, 10) || 1) + 1;
    loadMore.classList.add('is-loading');

    request(next)
      .then((res) => {
        if (res && res.success) {
          grid.insertAdjacentHTML('beforeend', res.data.html);
          setLoadMore(res.data);
          document.dispatchEvent(new CustomEvent('reveal:scan'));
        }
      })
      .finally(() => {
        loadMore.classList.remove('is-loading');
        busy = false;
      });
  };

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => filter(tab.dataset.csFilter));
  });

  if (loadMore) {
    loadMore.addEventListener('click', append);
  }
};

const initAll = () => {
  document.querySelectorAll('[data-cs-archive]').forEach((root) => {
    if (root.dataset.csInitialized) {
      return;
    }

    root.dataset.csInitialized = 'true';
    initCsArchive(root);
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAll);
} else {
  initAll();
}
